export default __webpack_public_path__ + "static/media/icon1.79ca8fde.svg";